import { useEffect, useState } from "react";
import { useDoubleTap } from "./useDoubleTap";
import { useSwipe } from "./useSwipe";

const BODY_HIDDEN_CLASS_NAME = "nav-menus-hidden";

export default function useMobilePageBarsVisibility({enabled = true} = {}) {
    const [isPageBarsHidden, setIsPageBarsHidden] = useState(false);

    // const hiddenBySwipe = useSwipe(30, 0.5, 120); функционал скрытия/открытия панелей навигации по свайпу. требует доработок
    const hiddenBySwipe = false;

    const onTouchEnd = useDoubleTap(() => {
        setIsPageBarsHidden((prevState) => !prevState);
    }, {
        delay: 300,
        maxDistance: 20,
    });

    useEffect(() => {
        if (!enabled) {
            return;
        }

        if (hiddenBySwipe === null) {
            return;
        }

        setIsPageBarsHidden(hiddenBySwipe);
    }, [enabled, hiddenBySwipe]);

    useEffect(() => {
        if (!enabled) {
            document.body.classList.remove(BODY_HIDDEN_CLASS_NAME);
            setIsPageBarsHidden(false);
            return;
        }

        const { classList } = document.body;

        if (isPageBarsHidden) {
            classList.add(BODY_HIDDEN_CLASS_NAME);
        } else {
            classList.remove(BODY_HIDDEN_CLASS_NAME);
        }

        return () => {
            classList.remove(BODY_HIDDEN_CLASS_NAME);
        };
    }, [enabled, isPageBarsHidden]);

    return {
        isPageBarsHidden,
        onTouchEnd,
    };
}
